export { default } from './StoreInformationBlock';
